<template>
  <div>
    <h1 class="text-center">Coupon List</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug mb-2 inline-block px-4 py-2 text-white hover:bg-green-900 rounded-full no-underline"
      to="/coupons-add"
    >
      Add Coupon
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}coupons/`,

      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Value (Rs.)", sortingParam: "coupon_value" },
          path: "coupon_value",
          formatter(price) {
            return `₹ ${price / 100}`
          },
        },
        {
          header: { textContent: "Special", sortingParam: "is_special" },
          path: "is_special",
          formatter(is_special) {
            return is_special ? `Yes` : "No"
          },
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/coupons-edit/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
}
</script>
